import { Theme, Components } from '@mui/material/styles';

export const components: Components<Theme> = {
    MuiFormLabel: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                fontSize: theme.typography.body2?.fontSize,
                marginBottom: "8px",
                '&.Mui-focused': {
                    color: theme.palette.primary.main,
                },
            })
        }
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: ({ theme, ownerState }: { theme: Theme, ownerState: any }) => ({
                width: "100%",
                height: ownerState.multiline ? "auto" : "48px",
                fontSize: theme.typography.caption?.fontSize,
                outline: "none",
                borderRadius: "4px",
                backgroundColor: theme.palette.background.default,
                '&:hover': {
                    backgroundColor: theme.palette.background.default,
                },
                '&.Mui-focused': {
                    backgroundColor: theme.palette.background.default,
                },
            })
        }
    },
    MuiButton: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                textTransform: "uppercase",
                fontSize: theme.typography.button?.fontSize,
                letterSpacing: theme.typography.button?.letterSpacing,
                borderRadius: "3px",
                padding: "0.85em 2.2em",
                fontWeight: 600,
                border: "none",
            })
        },
        variants: [
            {
                props: { variant: 'contained' },
                style: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                    }
                }),
            },
            {
                props: { variant: 'outlined' },
                style: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: 'transparent',
                    color: theme.palette.text.primary,
                    border: `1px solid ${theme.palette.text.primary}`,
                    '&:hover': {
                        backgroundColor: theme.palette.text.primary,
                        color: theme.palette.background.paper,
                    }
                }),
            },
            {
                props: { variant: 'text' },
                style: ({ theme }: { theme: Theme }) => ({
                    color: theme.palette.text.primary,
                    padding: 0,
                    borderBottom: `1px solid ${theme.palette.text.primary}`,
                    borderRadius: 0,
                    transition: "opacity 0.3s ease",
                    '&:hover': {
                        backgroundColor: 'transparent',
                        opacity: 0.6,
                    },
                }),
            },
        ]
    },
    MuiChip: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                borderRadius: "4px",
                fontWeight: 600,
            }),
        },
    },
    MuiCheckbox: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                "&.Mui-checked": {
                    color: theme.palette.primary.main,
                },
                '& .MuiSvgIcon-root': { fontSize: 20 },
            })
        }
    },
    MuiSelect: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                backgroundColor: theme.palette.background.paper,
                borderRadius: "4px",
                color: theme.palette.text.primary,
                '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                },
                '&.Mui-focused': {
                    backgroundColor: theme.palette.background.paper,
                },
            }),
            icon: ({ theme }: { theme: Theme }) => ({
                color: theme.palette.text.primary,
            }),
        },
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: ({ theme }: { theme: Theme }) => ({
                color: theme.palette.error.main,
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "14px",
                marginTop: "4px",
                marginLeft: "2px",
            }),
        },
    },
};
